module.exports = __webpack_public_path__ + "static/logo_transparent-7c2a1644f2e8f38d52670e485e1541f7.png";